
/* IE Support start*/
import 'core-js/es6/number';
import 'core-js/shim';
import 'core-js/es7/array';
/* IE Support End*/
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store/store'
import router from './router'
import commonColumns from '@/constants/common-columns.js' ;

import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
Vue.use(datePicker);


import VueSweetalert2 from 'vue-sweetalert2'
Vue.use(VueSweetalert2);

import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
Vue.use(VueGoodTable);

import vSelect from "vue-select";
Vue.component("v-select", vSelect);


import DOMPurify from "dompurify";
Vue.directive("fp-html", (el, binding) => {
  el.innerHTML = DOMPurify.sanitize(binding.value);
});

import appFooter from '@/components/Footer';
import LoadingContent from "@/components/LoadingContent.vue";
import CustomPagination from "@/components/layout/CustomPagination";
import DataTableFilterConfig from "@/components/DataTableFilterConfig";
import ClearCacheData from "@/components/ClearCacheData";

Vue.component("loading-content", LoadingContent);
Vue.component("app-footer", appFooter);
Vue.component("custom-pagination", CustomPagination);
Vue.component("data-table-filter-config", DataTableFilterConfig);
Vue.component("clear-cache-data", ClearCacheData);
//install using npm i -S vue-the-mask
// import VueTheMask from 'vue-the-mask'
// Vue.use(VueTheMask)

//vue-meta
import VueMeta from 'vue-meta';
Vue.use(VueMeta);

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
const options = {
  // You can set your default options here
};
Vue.use(Toast, options);

import envMixin from './mixins/envMixins.js';
Vue.mixin(envMixin);

// Import Pinia
import { createPinia, PiniaVuePlugin } from "pinia";

// Use Pinia plugin for Vue 2
Vue.use(PiniaVuePlugin);

const pinia = createPinia();

Vue.config.performance = true
Vue.config.productionTip = false

Vue.prototype.$commonColumns = commonColumns;

import Echo from "laravel-echo"
window.io = require('socket.io-client');

/*
commented because of no use
window.Echo = new Echo({
  broadcaster: 'socket.io',
  host: process.env.LARAVEL_ECHO_SERVER,//'http://localhost:6001', // laravel echo server url
});
*/

router.beforeEach((to, from, next) => {
  var fromPath = from['path']
  var toPath = to['path']
  var backModule = JSON.parse(localStorage.getItem("backModule"));
  var currentModule = to['path'].split('/');
  var previousModule = from['path'].split('/')
  // var newTab = JSON.parse(localStorage.getItem("newTab"));
  // console.log(newTab);
  localStorage.setItem('currentPath', JSON.stringify(toPath))
  localStorage.setItem('currentModule', JSON.stringify(currentModule[1]))

  if (from['path'].includes('list')) {
    localStorage.setItem("previousListPath", JSON.stringify(from['path']))
  }
  else {
    if (!from['path'].includes("edit") && !from['path'].includes("view") && !from['path'].includes("create") && !from['path'].includes("add") && from['path'] != '/') {
      localStorage.setItem("previousListPath", JSON.stringify(from['path']))
    }
  }

  if (fromPath != '/') {
    // store from path and previous path...
    if (currentModule[1] === previousModule[1]) {
      if ((backModule === "" || backModule === null) && previousModule[1] === currentModule[1]) {
        localStorage.setItem('previousPath', JSON.stringify(toPath))
      }

      localStorage.setItem('previousModule', JSON.stringify(previousModule[1]))
    }
    else {
        localStorage.setItem('previousPath', JSON.stringify(toPath))
    }

  } else {
    var backModule = JSON.parse(localStorage.getItem("previousModule"));
    localStorage.setItem('backModule', JSON.stringify(backModule))
  }

  if (!to.matched.length) {
  	next('/notFound');
  } else {
    //$("#loaderDiv").show();
  	next();
  }
})
router.afterEach(() => {
  //$("#loaderDiv").hide();
})
/* eslint-disable no-new */

new Vue({
  el: '#app',
  components: { App },
  // render: h => h(App),
  template: '<App/>',
  store,
  router,
  pinia
})



// WEBPACK FOOTER //
// ./src/main.js